import { Store } from '@moonpig/web-core-types'

export type Attributes = {
  [key: string]: string | number | boolean
}

export type DefaultSubjectAttributes = {
  storeId: Store['id']
  loggedIn: boolean
  isBot: boolean
  userIsFromAd: boolean
  customerSegments?: string[]
}

export const transformSubjectAttributes = (
  {
    customerSegments: customerSegmentsArray,
    ...defaultAttributes
  }: DefaultSubjectAttributes,
  subjectAttributes?: Attributes,
): Attributes => {
  const customerSegments = customerSegmentsArray?.map(s => `'${s}'`).join(',')

  return {
    ...defaultAttributes,
    ...subjectAttributes,
    ...(customerSegments && { customerSegments }),
  }
}
